import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "customer-reviews__header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "customer-reviews__author" }
const _hoisted_4 = { class: "customer-reviews__name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "customer-reviews__date" }
const _hoisted_7 = { class: "customer-reviews__title" }
const _hoisted_8 = { class: "customer-reviews__text" }

import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { type SwiperOptions } from 'swiper/types';

import { Review } from '@/@types/bankroll';

import 'swiper/css';
import 'swiper/css/pagination';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerReviews',
  props: {
    reviews: null
  },
  setup(__props: any) {

const props = __props as {
  reviews: Review[];
}



const breakpoints: SwiperOptions['breakpoints'] = {
  768: {
    slidesPerView: 2,
  },
  992: {
    slidesPerView: 3,
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    class: "customer-reviews",
    "slides-per-view": 1,
    "space-between": 24,
    modules: [_unref(Pagination)],
    pagination: "",
    breakpoints: breakpoints
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reviews, (review, i) => {
        return (_openBlock(), _createBlock(_unref(SwiperSlide), {
          key: i,
          class: "customer-reviews__item"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                class: "customer-reviews__avatar",
                src: review.avatar,
                alt: "avatar",
                width: "48",
                height: "48"
              }, null, 8, _hoisted_2),
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(review.author), 1),
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(review.date), 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(review.title), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(review.text), 1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["modules"]))
}
}

})